module.exports = __webpack_public_path__ + "static/media/background-gradation-bottom-Mobile.0ce883db.png";